/* eslint-disable react/prefer-stateless-function */
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { t } from 'utils/translates';
import UserReferralTable from '../../../../../../components/UserReferral/UserReferralTable';

class ReferralsList extends Component {
  render() {
    return (
      <React.Fragment>
        <div
          className="panel panel-default panel-heading_padding-large"
          id="statMyAffiliates"
        >
          <div className="panel-heading text-center">
            <h2 className="panel-title">
              <i className="fa fa-users fa-lg" /> {t('Ваши рефералы')}
            </h2>
          </div>
          <div className="panel-body">
            <UserReferralTable {...this.props} />
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default withRouter(ReferralsList);



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/ReferralProgram/ReferralMyStat/ReferralsList/ReferralsList.js